/**
 * DOM rendering helpers for site plan lot polygon paths.
 *
 * Applies lot status CSS class state to SVG path elements,
 * and resolves missing path IDs using an anchor-containment strategy.
 * Generic overlay DOM helpers (positioning, clip-path) live in overlayDom.js.
 *
 * @module searchResultsMap/components/lotPolygons
 */

import { lotStatusToKey } from '../services/sitePlanLots';

/**
 * CSS attribute selector for the SVG group element that contains all lot polygon paths.
 * Matches the `data-layer-type` attribute set by `buildLayerGroups` in overlayDom.js.
 */
const LOT_POLYGONS_SELECTOR = `g[data-layer-type='LotPolygons']`;

/**
 * Applies status CSS classes to all identified lot polygon paths in the SVG.
 * Paths receive their real status class when interactive, or the 'active' appearance
 * when below the zoom threshold.
 *
 */
function renderLotStatusClasses(svgRoot, lotStatusIndex, lotClasses, lotClassValues) {
  const allLotPaths = svgRoot.querySelectorAll(`${LOT_POLYGONS_SELECTOR} path[id]`);
  allLotPaths.forEach((path) => {
    path.classList.remove(...lotClassValues);
    const lot = lotStatusIndex.get(path.getAttribute('id'));
    path.classList.add(lotClasses[lotStatusToKey(lot?.status)]);
  });
}

export default renderLotStatusClasses;